import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { css } from "styled-components"
import { quillContentCSS } from "../quill/ui"
import PathwrightUI from "../ui/PathwrightUI"
import Screensize from "../ui/Screensize"
import { getTextColor } from "../ui/colors"
import { WithCSS } from "../utils/styles"
import { contentStyles } from "./typography"

const ContentText = React.forwardRef(function ContentText(
  { inverted, className, quill = true, ...rest },
  ref
) {
  return (
    <Screensize.Consumer>
      {(screensize) => (
        <PathwrightUI.Consumer>
          {({ backgroundColor }) => {
            const color = getTextColor({ inverted, backgroundColor })
            const placeholder = getTextColor({ inverted, backgroundColor, emphasis: "tertiary" }) // prettier-ignore
            const contentCSS = contentStyles({ screensize })
            const styles = css`
              width: 100%;
              color: ${color};
              &::placeholder {
                placeholder: ${placeholder};
              }
              & .ql-blank::before: {
                color: ${placeholder};
              }

              &.ql-editor {
                ${quillContentCSS}
              }

              &,
              &.ql-editor {
                ${contentCSS}
              }
            `

            return (
              <WithCSS
                {...rest}
                ref={ref}
                className={classnames(className, "ContentText", {
                  ["ql-editor"]: quill
                })}
                css={styles}
              />
            )
          }}
        </PathwrightUI.Consumer>
      )}
    </Screensize.Consumer>
  )
})

ContentText.propTypes = {
  inverted: PropTypes.bool,
  quill: PropTypes.bool
}

export default ContentText
